export var ProviderCategory;
(function (ProviderCategory) {
    ProviderCategory["CloudPlatform"] = "CLOUD_PLATFORM";
    ProviderCategory["Saas"] = "SAAS";
})(ProviderCategory || (ProviderCategory = {}));
